const DATE_FIELDS = ['date', 'birthday'];

export { DATE_FIELDS };
